module.exports = __webpack_public_path__ + "static/media/ASPNetPic.184a9e4b.jpg";